module.exports = __webpack_public_path__ + "static/fonts/notokr-bold.073dba1.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/views/surveys/sydney/font/notokr-bold.woff2
// module id = PK+3
// module chunks = 0